import { parseString } from "@de-xima/xima-common-js-lang";
import jQuery from "jquery";

import type { IComponentHandlerCallbacks, IInsertData } from "../../Header.ts";
import { getWidgetByVar } from "../../Util.ts";
import { AbstractComponentHandler } from "../AbstractComponentHandler.ts";

const DATA_WIDGET_VAR = "widgetVar";
const EVENT_TAGIFY_KEY = "keyup";
const EVENT_TAGIFY_FOCUS = "focus";
const SELECTOR_XI_TAGIFY = ".ui-tagify";

/**
 * Handler for components of type `xi:inputTags`.
 */
export class TagifyHandler extends AbstractComponentHandler {
  override accepts($element: JQuery): boolean {
    return this._getTagify($element) !== undefined;
  }

  override focus($element: JQuery): void {
    const tagify = this._getTagify($element);
    if (tagify !== undefined) {
      jQuery(tagify.getTagify().DOM.input).trigger("focus");
    }
  }

  override getInputElement($element: JQuery): JQuery {
    const tags = this._getTagify($element);
    return tags !== undefined ? tags.getTagifyTagsElement() : jQuery();
  }

  override initialize($element: JQuery, callbacks: IComponentHandlerCallbacks): boolean {
    const tagify = this._getTagify($element);
    if (tagify === undefined) {
      return false;
    }
    // Listen to CTRL+Space.
    jQuery(tagify.getTagify().DOM.input).on(EVENT_TAGIFY_KEY, (event) => {
      if (event.key === " " && (event.ctrlKey || event.metaKey)) {
        callbacks.onPlaceholderRequested();
      }
    });
    // Listen to focus.
    tagify.getTagify().on(EVENT_TAGIFY_FOCUS, () => callbacks.onFocus());
    return true;
  }

  override insertText($element: JQuery, data: IInsertData): void {
    const tagify = this._getTagify($element);
    if (tagify !== undefined) {
      tagify.addTag(data.content);
    }
  }

  /**
   * @param $element Input component.
   * @returns The widget instance for the input tags component.
   */
  private _getTagify($element: JQuery): PrimeFaces.widget.Tagify | undefined {
    const $tags = $element.find(SELECTOR_XI_TAGIFY);
    if ($tags.length !== 1) {
      return undefined;
    }
    return getWidgetByVar(parseString($tags.data(DATA_WIDGET_VAR)), PrimeFaces.widget.Tagify);
  }
}
